<template>
	<div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 门禁管理</el-breadcrumb-item>
				<el-breadcrumb-item>设备管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="区域名称" suffix-icon="el-icon-search" v-model.lazy="data.filterAreaStr"
							@change="filterArea" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSubDevice"
								@change="changeContainSubDevice">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="areas" :data="data.areas" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleAreaNodeClick"
							:filter-node-method="handleTreeFilter" default-expand-all>
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box left">
						<el-input v-model="data.filterstr" placeholder="设备名称/IP地址/序列号" class="handle-input mr10"
							size="large" style="width:300px"></el-input>
						<el-button type="primary" icon="el-icon-search" size="small" @click="search"
							v-if="power.search">搜索
						</el-button>
					</div>
					<div class="handle-box right">
						<el-button type="primary" @click="toChangeDevice" v-if="power.devicechange" size="small"
							:disabled="!data.cur || data.cur.factory != 1 || (data.cur.devType != 3 && data.cur.devType != 6)">
							<i class="if-lcon-shebeigenghuan"></i>更换设备
						</el-button>
					</div>

					<el-table ref="table" :data="data.rows" border class="table" row-key="id"
						@selection-change="handleSelectionChange" @cell-click="handleCellClick"
						@current-change="handleCurrentChange" highlight-current-row height="600">
						<el-table-column type="selection" width="40" :selectable="enableSelection">
						</el-table-column>
						<el-table-column prop="areaName" label="区域" width="140" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="serialNumber" label="设备序列号" width="200" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="name" label="设备名称" width="220" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="factory" label="设备品牌" width="110">
							<template slot-scope="scope">
								<span v-if="scope.row.factory==1">海康</span>
								<span v-else-if="scope.row.factory==2">中控</span>
							</template>
						</el-table-column>
						<el-table-column prop="devType" label="设备类型" width="190" show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.devType == 1">门禁控制器</span>
								<span v-else-if="scope.row.devType == 3">人脸识别仪</span>
								<span v-else-if="scope.row.devType == 4">人证对比采集仪器</span>
								<span v-else-if="scope.row.devType == 6">出入口抓拍机</span>
								<span v-else>其他</span>
							</template>
						</el-table-column>
						<el-table-column prop="ipAddress" label="设备IP" width="180">
						</el-table-column>
						<el-table-column prop="port" label="通讯端口" width="110">
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</div>

		<el-dialog title="更换设备" :visible.sync="visible.devicechange" v-if="power.devicechange" width="760px" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="160px">
				<el-form-item label="设备名称">
					<el-input v-model="data.device.name" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="原设备序列号">
					<el-input v-model="data.device.oldSerialNumber" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="新设备序列号">
					<el-input v-model="data.device.serialNumber" size="large" readonly></el-input>
				</el-form-item>
				<el-form-item label="设备Ip">
					<ipInput ref="ipinput" :configIp="data.device.ipAddress" @getIp="getIp" ipType="ip"></ipInput>
				</el-form-item>
				<el-form-item label="设备端口">
					<el-input v-model="data.device.port" size="large"></el-input>
				</el-form-item>
				<el-form-item label="管理密码">
					<el-input v-model="data.device.password" size="large" show-password ref="devPassword"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" v-if="!data.device.checked" @click="doTestDevice">测试连接</el-button>
				<el-button type="primary" v-else @click="doChangeDevice">确认更换</el-button>
				<el-button @click="visible.devicechange = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import ipInput from '../usercontrol/IpInput.vue'
	export default {
		name: 'devicemanager',
		data() {
			return {
				data: {
					filterstr: '',
					rows: [],
					cur: false,
					selections: [],
					areas: [],
					curAreaId: 0,
					filterAreaStr: '',
					containSubDevice: true,
					device: {
						name: '',
						oldSerialNumber: '',
						serialNumber: '',
						ipAddress: '',
						port: 0,
						password: '',
						checked: false
					}
				},
				visible: {
					devicechange: false,
					loading: false
				},
				power: {
					pageId: 71,
					search: false,
					devicechange: false
				}
			}
		},
		methods: {
			enableSelection(r, idx) {
				return true;
			},
			search() {
				let ths = this;
				ths.visible.loading = true;
				let params = '?sign=' + window.$gloable.userinfo.sign + '&areaid=' + ths.data.curAreaId + '&filterstr=' +
					ths.data.filterstr + '&containdown=' + (ths.data.containSubDevice ? 1 : 0);
				window.ax.get('api/device/device/list' + params, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.rows = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			changeContainSubDevice() {
				this.search();
			},
			filterArea() {
				this.data.filterAreaStr = this.data.filterAreaStr.toLowerCase();
				this.$refs.areas.filter(this.data.filterAareStr);
			},
			handleAreaNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curAreaId != data.id) {
					ths.data.curAreaId = data.id;
					ths.data.filterstr = '';
					ths.search();
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.search(true);
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			handleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.table.toggleRowSelection(row, this.data.selections.indexOf(row) == -1);
				}
			},
			handleCurrentChange(cur) {
				this.data.cur = cur;
			},
			getIp(data) {
				this.data.device.ipAddress = data.ip;
			},
			toChangeDevice() {
				let ths = this;
				if (ths.data.cur.factory == 1) {
					ths.data.device.name = ths.data.cur.name;
					ths.data.device.ipAddress = ths.data.cur.ipAddress;
					ths.data.device.oldSerialNumber = ths.data.cur.serialNumber;
					ths.data.device.port = ths.data.cur.port;
					ths.data.device.password = '';
					ths.visible.devicechange = true;
					setTimeout(() => {
						ths.$refs.ipinput.init();
					}, 100);
				} else {
					ths.$message.warning('请选择海康设备进行更换操作');
				}
			},
			doTestDevice() {
				let ths = this;
				if (ths.data.device.password) {
					ths.visible.loading = true;
					let opt = {
						sign: window.$gloable.userinfo.sign,
						ipaddress: ths.data.device.ipAddress,
						port: ths.data.device.port,
						password: ths.data.device.password
					};
					window.ax.post('api/device/device/testdevice', opt).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							ths.data.device.serialNumber = data.data;
							ths.data.device.checked = true;
							ths.$message.success(data.message);
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
				} else {
					ths.$message.error('请输入设备管理密码');
					ths.$refs.devPassword.focus();
				}
			},
			doChangeDevice() {
				let ths = this;
				if (ths.data.device.checked) {
					ths.visible.loading = true;
					let opt = {
						sign: window.$gloable.userinfo.sign,
						id: ths.data.cur.id,
						ipaddress: ths.data.device.ipAddress,
						port: ths.data.device.port,
						password: ths.data.device.password,
						serialNumber: ths.data.device.serialNumber
					};
					window.ax.post('api/device/device/changedevice', opt).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							ths.$message.success(data.message);
							ths.search();
							ths.visible.devicechange = false;
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
				} else {
					ths.$message.error('请先测试连接');
					ths.$refs.devPassword.focus();
				}
			}
		},
		created() {
			this.baseJS.initPower(this.power);
			this.api.loadAreasTree(this, 'data.areas', false);
			this.search();
		},
		mounted() {},
		components: {
			ipInput
		}
	}
</script>

<style>
	.ml10 {
		margin-left: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
		margin-left: 10;
	}

	.right {
		float: right;
		margin-right: 10;
	}

	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.el-tree-node__content {
		height: 36px !important;
	}

	.dialog-footer {
		height: 30px;
	}
</style>
